import {
  SET_ACTIVE_SCHEDULE
} from '../actions';

export default function (state = {}, action) {

  switch(action.type) {
    case SET_ACTIVE_SCHEDULE:
      return action.payload;

    default:
      return state;
  }
}